import React from 'react';
import DialogContent from "@mui/material/DialogContent";
import { SwiperImg } from "../../../../../../components/SwiperImg";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";

const ImageDialog = ({open, onClose, data}) => {
    
    return (
        <Dialog
            fullWidth
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
        >
            <DialogContent>
                <SwiperImg img={data} />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Fechar</Button>
            </DialogActions>
        </Dialog>
    );
};

export default ImageDialog;
